import * as L from 'leaflet';

import { getPopupSupport } from '../lib';
import { getSupportIcon, zoomThreshold } from '../options';
import { searchProps } from '../lib';

export function initSupportLayer(map, state) {
    return L.geoJSON(null, {
        filter: (feature) => {
            const isGroupChecked = state.groups.some(
                (r) => feature.properties.group.name.indexOf(r) >= 0
            );

            if (state.searchTerm !== '') {
                const matchesSearchTerm = searchProps(
                    feature,
                    state.searchTerm
                );

                return matchesSearchTerm;
            }

            return isGroupChecked;
        },
        pointToLayer: function (feature, latlng) {
            let supportIcon = L.divIcon(
                getSupportIcon(feature.properties.group.id)
            );
            return L.marker(latlng, { icon: supportIcon });
        },
        onEachFeature: function (feature, layer) {
            const customPopup = getPopupSupport(
                feature.properties.name,
                feature.properties.type,
                feature.properties.location,
                feature.properties.description,
                feature.properties.url,
                feature.properties.mail
            );
            layer.bindPopup(customPopup, { className: 'lmz-popup' });

            const customTooltip = feature.properties.name;
            /* eslint-disable indent */
            map.getZoom() >= zoomThreshold
                ? layer.bindTooltip(customTooltip, {
                      permanent: true,
                      opacity: 0.9,
                  })
                : layer.bindTooltip(customTooltip, {
                      permanent: false,
                      opacity: 0,
                  });
            /* eslint-enable indent */
        },
    });
}
